export default __webpack_public_path__ + "static/media/img-1.3869811c.jpg";